import { useContext } from "react";
import { FileUploaderContext } from "./file-upload-provider";

// Hook to get the current status of all file uploads
export const useFileUploadStatus = () => {
  const context = useContext(FileUploaderContext);
  if (context === undefined) {
    throw new Error(
      "useFileUploadStatus must be used within a FileUploadProvider",
    );
  }
  const { items } = context;
  return { items };
};
